import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const samlProviderTextDescriptionStyle: React.CSSProperties = {
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const samlProviderDarkHighlightTextStyle: React.CSSProperties = {
    fontWeight: 'bold'
};

export const samlDisabled: React.CSSProperties = {
    pointerEvents: 'none',
    opacity: CommonStyles.Opacity.DisabledOpacity,
    cursor: 'default'
};

export const samlTableTopPadding: React.CSSProperties = {
    paddingTop: 20
};

export const samlTableStyle: React.CSSProperties = {
    fontWeight: 'normal',
    fontSize: CommonStyles.Sizes.SmallFontSize
};

export const emailMappingTextBoxStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    display: 'table'
};